import {createFixedLayerId} from '../../mapbox/concatMapboxStyles';

export const trackFixedLayerIds = {
    remoteUserTracks: {
        casing: createFixedLayerId(),
        line: createFixedLayerId(),
    },
    remoteUserRoutes: {
        casing: createFixedLayerId(),
        line: createFixedLayerId(),
    },
    localUser: {
        point: createFixedLayerId(),
        casing: createFixedLayerId(),
        'route-symbol': createFixedLayerId(),
        normal: createFixedLayerId(),
        preview: createFixedLayerId(),
        loading: createFixedLayerId(),
    },
    remoteHighlight: {
        casing: createFixedLayerId(),
        line: createFixedLayerId(),
    },
    localHighlight: {
        point: createFixedLayerId(),
        casing: createFixedLayerId(),
        'route-symbol': createFixedLayerId(),
        normal: createFixedLayerId(),
        preview: createFixedLayerId(),
        loading: createFixedLayerId(),
    }
};

export const publicTrackFixedLayerIds = {
    line: createFixedLayerId(),
};

export const waypointFixedLayerIds = {
    searchResult: {
        pin: createFixedLayerId(),
    },
    remoteUser: {
        pin: createFixedLayerId(),
    },
    localUser: {
        pin: createFixedLayerId(),
        circle: createFixedLayerId(),
    },
    remoteHighlight: {
        pin: createFixedLayerId(),
    },
    localHighlight: {
        pin: createFixedLayerId(),
        circle: createFixedLayerId(),
    }
};

export const areaFixedLayerIds = {
    remoteUser: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    },
    localUser: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    },
    remoteHighlight: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    },
    localHighlight: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    }
};
